/**
 * Utilities for preserving/clearing client-side hash routes before MSAL redirects.
 *
 * Purpose:
 * - Avoid redirect loops / broken routing when MSAL adds auth params to the hash
 * - Preserve the user's in-app route so it can be restored post-login
 */

const MSAL_REDIRECT_ROUTE_KEY = 'msal_redirect_route';

/**
 * Save the current hash route (if it looks like an app route, not an auth response),
 * then clear the hash from the URL so MSAL can own the callback hash safely.
 */
export function stashHashRouteForMsalRedirect(currentHash: string = window.location.hash): void {
    if (!currentHash) return;

    const hash = String(currentHash);
    // If MSAL already put auth params in the hash, don't overwrite the stored route.
    if (hash.includes('code=') || hash.includes('error=')) return;

    sessionStorage.setItem(MSAL_REDIRECT_ROUTE_KEY, hash);
    window.history.replaceState(null, '', window.location.pathname);
}

export function getStashedMsalRedirectRoute(): string | null {
    return sessionStorage.getItem(MSAL_REDIRECT_ROUTE_KEY);
}

export function clearStashedMsalRedirectRoute(): void {
    sessionStorage.removeItem(MSAL_REDIRECT_ROUTE_KEY);
}

